import React from "react";

interface IProps {
    text: string;
    height?: string;
    width?: string;
    bg?: string;
    textStyle?: string;
    rounded?: string;
    justify?: string;
    className?: string;
    onClick?(event: React.MouseEvent<HTMLDivElement>): void;
}

const Button: React.FC<IProps> = ({
    text,
    height,
    width,
    bg,
    textStyle,
    rounded,
    justify,
    onClick,
    children,
    className
}) => {
    return (
        <div
            onClick={onClick}
            className={`
                ${height || 'h-10'} 
                ${width || 'w-40'} 
                ${rounded || 'rounded-md'} 
                ${bg || 'bg-blue'} ${textStyle || 'text-white'} 
                ${justify || 'justify-center'} 
                flex items-center cursor-pointer
                ${className}
            `}
        >
            {children || text}
        </div>
    )
}

export default Button
